<template>
  <div class="wrapper px-4 py-5 px-md-5 text-center text-lg-start">
    <div class="container">
      <div class="row gx-lg-5">
        <div class="col-lg-6 mb-5 mb-lg-0">
          <div class="container-fluid mb-5">
            <div
              class="iq-link d-flex flex-column flex-sm-row align-items-center justify-content-between"
            >
              <a href="https://e-sea.kkp.go.id/perizinan">
                <img
                  class="img-fluid mb-3 mb-sm-0 order-sm-1"
                  style="width: 120px"
                  src="./assets/images/logo e-sea-black.png"
                  alt="logo"
                  loading="lazy"
                />
              </a>

              <h5
                style="margin-left: 5px"
                data-setting="app_name"
                class="mb-0 ml-lg-3 display-12 fw-bold ls-tight order-sm-2 text-center text-sm-left"
              >
                DIREKTORAT PEMANFAATAN RUANG KOLOM PERAIRAN DAN DASAR LAUT
                <br />
                DIREKTORAT JENDERAL PENATAAN RUANG LAUT
              </h5>
            </div>
          </div>
          <div class="container-fluid">
            <img
              class="img-fluid mt-lg-5 d-none d-sm-block"
              src="./assets/images/gambar.png"
              alt="logo-img"
              loading="lazy"
            />
          </div>
        </div>

        <div class="col-lg-6 mt-4 mb-lg-0">
          <div class="card">
            <div class="card-body py-5 px-md-5">
              <div class="mb-5 mb-lg-0 text-center">
                <h1 class="my-5 display-6 fw-bold ls-tight">
                  <span class="text-primary">Lupa</span> Kata Sandi
                </h1>
                <h5 class="my-5">
                  Masukkan alamat email yang terdaftar untuk menerima kata sandi
                  Anda.
                </h5>
              </div>
              <form class="mt-4">
                <div class="form-group">
                  <label class="form-label" for="email">Email</label>
                  <input
                    type="text"
                    v-model="form.email"
                    class="form-control"
                    id="email"
                    placeholder="Email"
                    name="Email"
                    v-validate="'required|email'"
                    autocomplete="email"
                  />
                  <small class="text-danger" v-if="errors.has('Email')">
                    {{ errors.first('Email') }}
                  </small>
                </div>
                <VueRecaptcha
                  @verify="markRecaptchaAsVerified"
                  sitekey="6LcWcyopAAAAAMIHDH7BVEQuyt-Qw1T0C99UG6jz"
                ></VueRecaptcha>
                <strong>{{ pleaseTickRecaptchaMessage }}</strong>
                <div class="d-grid pt-3">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="checkIfRecaptchaVerified"
                    :disabled="isLoading"
                  >
                    <template v-if="!isLoading">Kirim Email</template>
                    <Loader v-else />
                  </button>
                </div>
                <div class="text-center mt-3">
                  <a href="/login" class="text-primary">
                    Kembali ke halaman login
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style src="./assets/css/hope-ui.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/pro.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/custom.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/dark.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/customizer.min.css?v=2.0.0" lang="css" />
<style src="./assets/css/rtl.min.css?v=2.0.0" lang="css" />
<!-- Library Bundle Script -->
<script src="./assets/js/core/libs.min.js"></script>
<!-- Plugin Scripts -->
<!-- <style src="./assets/css/custom/login-custom.css" lang="css" /> -->
<!-- Slider-tab Script -->
<script src="./assets/js/plugins/slider-tabs.js"></script>
<!-- Lodash Utility -->
<script src="./assets/vendor/lodash/lodash.min.js"></script>
<!-- Utilities Functions -->
<script src="./assets/js/iqonic-script/utility.js"></script>
<!-- Settings Script -->
<script src="./assets/js/iqonic-script/setting.js"></script>
<!-- Settings Init Script -->
<script src="./assets/js/setting-init.js"></script>
<!-- External Library Bundle Script -->
<script src="./assets/js/core/external.min.js"></script>
<!-- Widgetchart Script -->
<script src="./assets/js/charts/widgetcharts.js?v=2.0.0" defer></script>
<!-- Dashboard Script -->
<script src="./assets/js/charts/dashboard.js?v=2.0.0" defer></script>
<script src="./assets/js/charts/alternate-dashboard.js?v=2.0.0" defer></script>
<!-- Hopeui Script -->
<script src="./assets/js/hope-ui.js?v=2.0.0" defer></script>
<script src="./assets/js/hope-uipro.js?v=2.0.0" defer></script>
<script src="./assets/js/sidebar.js?v=2.0.0" defer></script>

<script>
import { VueRecaptcha } from 'vue-recaptcha'
import { mapState, mapActions } from 'vuex'
import { Validator } from 'vee-validate'
import axios from 'axios'
import Swal from 'sweetalert2'
import Loader from '../../components/Loader/Loader'

export default {
  components: { VueRecaptcha, Loader },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      form: {
        email: '',
      },
      recaptchaVerified: false,
      pleaseTickRecaptchaMessage: '',
      isLoading: false,
    }
  },
  methods: {
    ...mapActions('auth', ['receiveToken', 'receiveLogin']),
    markRecaptchaAsVerified() {
      this.pleaseTickRecaptchaMessage = ''
      this.recaptchaVerified = true
    },
    async checkIfRecaptchaVerified() {
      await this.$validator.validateAll()
      if (this.$validator.errors.any()) return

      if (!this.recaptchaVerified) {
        this.pleaseTickRecaptchaMessage = 'Please tick recaptcha.'
        return true
      }
      this.resetPassword()
    },
    async resetPassword() {
      try {
        this.isLoading = true
        const res = await axios.post(
          `${this.baseapi}api/auth/forgetPassword`,
          this.form,
        )
        await Swal.fire('Berhasil', res.data.message, 'success')
        this.$router.push('/login')
      } catch (error) {
        if (error.status >= 500) {
          Swal.fire('Error', 'Sedang terjadi kendala pada Server', 'error')
        } else {
          Swal.fire(
            'Kirim Email Gagal',
            error.response?.data?.message ||
              'Terjadi kesalahan saat kirim email reset password',
            'warning',
          )
        }
      } finally {
        this.isLoading = false
      }
    },
  },
  mounted() {
    const dictionary = {
      id: {
        messages: {
          required: (fieldName) => `${fieldName} wajib diisi`,
          email: (fieldName) => `Format email tidak sesuai`,
        },
      },
    }
    Validator.localize(dictionary)
    this.$validator.localize('id')
  },
}
</script>
